var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500px" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.onenter.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c("span", { staticClass: "headline" }, [
                _vm._v("World Region (" + _vm._s(this.rules.name) + ")"),
              ]),
              _c("v-spacer"),
              _c("r-authorize", {
                attrs: {
                  master: _vm.masterAccess,
                  locked: _vm.model.locked,
                  enabled: _vm.model.enabled,
                },
                on: {
                  "update:locked": function ($event) {
                    return _vm.$set(_vm.model, "locked", $event)
                  },
                  "update:enabled": function ($event) {
                    return _vm.$set(_vm.model, "enabled", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-col",
                { attrs: { cols: "4", sm: "2", md: "2" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-2",
                      attrs: { small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.showPreview()
                        },
                      },
                    },
                    [_vm._v("View JSON")]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Region:", "hide-details": "" },
                        model: {
                          value: _vm.model.region,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "region", _vm._n($$v))
                          },
                          expression: "model.region",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Game Level:", "hide-details": "" },
                        model: {
                          value: _vm.model.gameLevel,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "gameLevel", _vm._n($$v))
                          },
                          expression: "model.gameLevel",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Level lock:", "hide-details": "" },
                        model: {
                          value: _vm.model.userLevel,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "userLevel", _vm._n($$v))
                          },
                          expression: "model.userLevel",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "8", sm: "8" } },
                    [
                      _c("r-item-dropdown", {
                        attrs: { label: "Blocker:", model: _vm.model.blocker },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "blocker", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      attrs: { cols: "12", sm: "4", md: "4", align: "center" },
                    },
                    [
                      !!_vm.model.search
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "my-4 fill-width",
                              attrs: { small: "", color: "success" },
                              on: { click: _vm.search },
                            },
                            [_vm._v("Search ")]
                          )
                        : _c(
                            "v-btn",
                            {
                              staticClass: "my-4 fill-width",
                              attrs: {
                                small: "",
                                outlined: "",
                                color: "primary",
                              },
                              on: { click: _vm.search },
                            },
                            [_vm._v("Search")]
                          ),
                    ],
                    1
                  ),
                  _c("v-col", { attrs: { cols: "12" } }),
                ],
                1
              ),
              _c(
                "v-expansion-panels",
                [
                  _c("r-tile-panel", {
                    attrs: { items: _vm.model.tiles, title: "Cells" },
                    on: {
                      "update:items": function ($event) {
                        return _vm.$set(_vm.model, "tiles", $event)
                      },
                    },
                  }),
                  _c("r-currency-panel", {
                    attrs: { items: _vm.model.money, title: "Currency" },
                    on: {
                      "update:items": function ($event) {
                        return _vm.$set(_vm.model, "money", $event)
                      },
                    },
                  }),
                  _c("r-reward-panel", {
                    attrs: { model: _vm.model.reward, title: "Reward" },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.model, "reward", $event)
                      },
                    },
                  }),
                  _c("r-trigger-panel", {
                    attrs: { items: _vm.model.triggers, title: "Triggers" },
                    on: {
                      "update:items": function ($event) {
                        return _vm.$set(_vm.model, "triggers", $event)
                      },
                    },
                  }),
                  _c("r-wonders-panel", {
                    attrs: { items: _vm.model.wonders, title: "Wonders" },
                    on: {
                      "update:items": function ($event) {
                        return _vm.$set(_vm.model, "wonders", $event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              !_vm.lockedAssess || _vm.masterAccess
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: { click: _vm.save },
                    },
                    [_vm._v(" Save ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("r-search-dialog", { ref: "r-search-dialog" }),
      _c("r-preview-dialog", { ref: "preview-dialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }